<template>
	<div class="main">
		<label class="label-form">{{labelText}}</label>
		<v-menu
			lazy
			offset-y
			full-width
			v-model="menu"
			transition="scale-transition"
			class="menu-date-picker"
			max-width="290px"
			:nudge-left="40"
			@input="changeIconProduct">
			<v-text-field
				readonly
				single-line
				hide-details
				slot="activator"
				:class="[bgIconBlue ? 'product-date-picker' : null]"
				:prepend-icon="icon"
				:label="labelText"
				v-bind="$attrs"
				:append-icon="arrowIconProduct"
				:append-icon-cb="toggleIconProductDate"
				@input="sendDate"
				:value="value"
			></v-text-field>
			<v-date-picker
				no-title
				scrollable
				v-bind="$attrs"
				@input="sendDate"
				:value="value"
			>
			</v-date-picker>
		</v-menu>
	</div>
</template>

<script>

function sendDate(value) {
	this.$emit('input', value);
}

function toggleIconProductDate() {
	this.onChangeProduct = !this.createdAt;
}

function changeIconProduct(result) {
	this.onChangeProduct = result;
}

function arrowIconProduct() {
	return this.onChangeProduct ? 'arrow_drop_up' : 'arrow_drop_down';
}


function data() {
	return {
		menu: false,
		onChangeProduct: false,
	};
}

export default {
	name: 'select-date',
	computed: {
		arrowIconProduct,
	},
	inheritAttrs: false,
	data,
	methods: {
		changeIconProduct,
		sendDate,
		toggleIconProductDate,
	},
	props: {
		bgIconBlue: {
			default: false,
			type: Boolean,
		},
		icon: {
			default: '',
			type: String,
		},
		labelText: {
			default: '',
			type: String,
		},
		value: {
			default: null,
		},
	},
};
</script>
<style lang="scss" scoped>
.main {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// select-date.vue?e57f0aa0